<template>
  <div class="vx-row progress-container">
    <div class="vx-col w-full">
      <h5 class="mb-6">{{ stepTwo ? 'Step 2' : 'Step 1' }}</h5>
      <div class="progress-bar">
        <vs-progress :height="2" :percent="!stepTwo ? 5 : 100" color="dark"/>
      </div>
      <div class="vx-row progress-checkpoints">
        <div class="vx-col w-1/2 step-one-checkpoint">
        <div>
          <span :class="stepTwo ? 'inactive' : ''">1</span>
          <div class="label pt-2"><b>General Details</b></div>
        </div>
        </div>
        <div class="vx-col w-1/2 step-two-checkpoint">
          <div>
            <span :class="!stepTwo ? 'inactive' : ''">2</span>
            <div class="label pt-2"><b>Addresses</b></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserProgressBar",
  props: {
    stepTwo: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {}
  },
  computed: {
  }
}
</script>

<style scoped>

</style>
